import Request from './request';

const normalizeResponse = res => ({
  ...res,
  status: res.success ? 1 : 0,
});

export const apiGetRecurringRules = companyId =>
  Request.call({
    url: `/company/${companyId}/recurring-rules`,
    method: 'GET',
  }).then(normalizeResponse);

export const apiCreateRecurringRule = (companyId, data) =>
  Request.call({
    url: `/company/${companyId}/recurring-rules`,
    method: 'POST',
    data,
  }).then(normalizeResponse);

export const apiUpdateRecurringRule = (companyId, ruleId, data) =>
  Request.call({
    url: `/company/${companyId}/recurring-rules/${ruleId}`,
    method: 'PUT',
    data,
  }).then(normalizeResponse);

export const apiDeleteRecurringRule = (companyId, ruleId) =>
  Request.call({
    url: `/company/${companyId}/recurring-rules/${ruleId}`,
    method: 'DELETE',
  }).then(normalizeResponse);

export const apiGetAutomatedOrders = (companyId, params) =>
  Request.call({
    url: `/company/${companyId}/automated-orders`,
    method: 'GET',
    params,
  }).then(normalizeResponse);
